import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { AdminSidebar } from './AdminSidebar';

interface AdminShellProps {
  children: ReactNode;
}

/**
 * Admin layout: icon column beside the current admin page.
 * The column stretches with the page so its background reaches the bottom.
 * Mounted only around `/admin` routes, not in the product rail.
 */
export function AdminShell({ children }: AdminShellProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'stretch', flex: 1, minHeight: '100vh' }}>
      <AdminSidebar />
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
    </Box>
  );
}
